export const ContractThreadLevel = {
  Threads: 0,
  Category: 1,
  Discussions: 2,
  SignatureRounds: 3,
  SignatureRound: 4,
  Message: 5,
  Editor: 6
};
